'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Lottery = void 0;
var transport_1 = require("../../transport");
var Lottery = /** @class */ (function () {
    function Lottery() {
    }
    Lottery.prototype.createBet = function (params) {
        return transport_1.transport.request('lottery/createBet', params);
    };
    Lottery.prototype.bulkBuying = function (params) {
        return transport_1.transport.request('lottery/bulkBuying', params);
    };
    Lottery.prototype.getOpenDraws = function (params) {
        return transport_1.transport.request('lottery/getOpenDraws', params);
    };
    Lottery.prototype.getPreviousDraws = function (params) {
        return transport_1.transport.request('lottery/getPreviousDraws', params);
    };
    Lottery.prototype.getProviders = function () {
        return transport_1.transport.request('lottery/getProviders');
    };
    Lottery.prototype.getUserBets = function (params) {
        return transport_1.transport.request('lottery/getUserBets', params);
    };
    Lottery.prototype.getUserBetResults = function (params) {
        return transport_1.transport.request('lottery/getUserBetResults', params);
    };
    Lottery.prototype.getPayoutTable = function (params) {
        return transport_1.transport.request('lottery/getPayoutTable', params);
    };
    Lottery.prototype.getWinningNumbersForDraw = function (params) {
        return transport_1.transport.request('lottery/getWinningNumbersForDraw', params);
    };
    Lottery.prototype.get = function (params) {
        return transport_1.transport.request('lottery/get', params);
    };
    Lottery.prototype.getAll = function (params) {
        return transport_1.transport.request('lottery/getAll', params);
    };
    Lottery.prototype.subscribe = function (params) {
        return transport_1.transport.request('lottery/subscribe', params);
    };
    Lottery.prototype.unsubscribe = function (params) {
        return transport_1.transport.request('lottery/unsubscribe', params);
    };
    return Lottery;
}());
exports.Lottery = Lottery;
